export function focusAutofocusFieldOnOpen(callerOnOpenAutoFocus?: (event: Event) => void) {
  return (event: Event) => {
    callerOnOpenAutoFocus?.(event)
    if (event.defaultPrevented) return
    const autofocusField = (event.currentTarget as HTMLElement).querySelector<HTMLElement>("[data-autofocus]")
    if (!autofocusField) return
    event.preventDefault()
    autofocusField.focus()
  }
}
